import dayjs from 'dayjs';

export const dateDiff = (date: DateLike, compareDate: DateLike) =>
  dayjs(date).diff(compareDate);

export const formatDate = (
  dateValue: DateLike,
  format?: string,
  isUtc = false,
) =>
  isUtc
    ? dayjs(dateValue)
        .utc()
        .format(format ?? 'YYYY-MM-DD HH:mm:ss')
    : dayjs(dateValue).format(format ?? 'YYYY-MM-DD HH:mm:ss');

export const toLocalDateString = (
  dateValue: DateLike,
  withTime = false,
  defaultValue = '',
) =>
  !dateValue
    ? defaultValue
    : formatDate(dateValue, `YYYY.MM.DD${withTime ? ' A h:mm' : ''}`);
